import appVoala from './appVoala.png';
import bannerBlog from './bannerBlog.jpg';
import bannerPrincipal from './bannerPrincipal.jpg';
import bannerRecomenda from './bannerRecomenda.jpg';
import Pais from './pais.png';
import bannerGoias from './bannerGoias.png';
import hotelGoiania01 from './hotelGoiania01.jpg';
import hotelGoiania02 from './hotelGoiania02.jpg';
import bannerPipa from './bannerPipa.png';
import hotelPipa0 from './hotelPipa0.jpg';
import hotelPipa1 from './hotelPipa1.jpg';
import hotelPipa2 from './hotelPipa2.jpg';
import inverno from './inverno.png';
import anoNovo from './banner-ano-novo.png';
import carroESeguro from './carroESeguro.png';
import BannerVoaláFlexibilidadeCA from './banner-voala-flexibilidade-ca.jpg';
import BannerVoalaCupomDiasDosPais from './banner-voala-cupom-dia-dos-pais.jpg';
import BannerPlanejeProximaViagem from './planeje-proxima-viagem.png';
import BannerSeuPerfilViajante from './seu-perfil-viajante.png';
import BannerPromocoesEspeciais from './banner-promocoes-especias.png';
import BannerPromocoesEspeciaisSemCupom from './banner-promocoes-especias-sem-cupom.png';
import BannerTemporario from './banner-temporario.jpg';
import BannerAnoNovo from './ano-novo-banner.png';
import BannerEbook from './banner-ebook.png';
import IconFlight from './icone-aviao.png';
import blackFriday2021Modal from './blackFriday2021Modal.png';

export const ALL_HOME = {
  appVoala,
  bannerBlog,
  bannerPrincipal,
  bannerRecomenda,
  Pais,
  inverno,
  anoNovo,
  bannerGoias,
  hotelGoiania01,
  hotelGoiania02,
  bannerPipa,
  hotelPipa0,
  hotelPipa1,
  hotelPipa2,
  BannerVoaláFlexibilidadeCA,
  BannerVoalaCupomDiasDosPais,
  carroESeguro,
  BannerPlanejeProximaViagem,
  BannerSeuPerfilViajante,
  BannerPromocoesEspeciais,
  BannerPromocoesEspeciaisSemCupom,
  BannerTemporario,
  BannerAnoNovo,
  BannerEbook,
  IconFlight,
  blackFriday2021Modal
};
